import { useQuery } from "@tanstack/react-query";
import { chatManagerApiService } from "./ChatManagerApiService";
import { SummaryResponse } from "./models";

export const useChatSummary = (
  sessionId: string,
  language: string,
  enabled: boolean
) => {
  const {
    data,
    isFetching,
    isError,
    refetch
  } = useQuery<SummaryResponse, Error>({
    queryKey: ["chatSummary", sessionId, language],
    queryFn: () => chatManagerApiService.generateSummary(sessionId, language),
    enabled: enabled && !!sessionId,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });

  return { data, isLoading: isFetching, isError, refetch };
};

